// extracted by mini-css-extract-plugin
export var autoExpand = "_2l-8";
export var container = "_2l-7";
export var containerWidth = "_2l-5";
export var disabled = "_2l-2";
export var error = "_2l-3";
export var fullWidth = "_2l-6";
export var inputWrapper = "_2l-0";
export var small = "_2l-1";
export var textarea = "_2l-4";